

define(['angular', './directive'], function (angular) {
  (function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
  })(window.angular);
  angular.module('xo-add-card.selectcard.route', ['xo-add-card.selectcard.directive']).factory('$SelectCardRoute', ['$ComponentRoute', function ($ComponentRoute) {
    return $ComponentRoute.extend('SelectCardRoute', {
      name: 'selectCard',
      directive: 'xo-select-card',
      titleContent: 'asideHeader.selectCard',
      children: []
    });
  }]);
});


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-wallet-components/src/add-card/selectcard/route.js
// module id = ../node_modules/xo-wallet-components/src/add-card/selectcard/route.js
// module chunks = 0